<!-- <app-navbar></app-navbar> -->
<router-outlet></router-outlet>
<div class="envLabel" *ngIf="envName === 'dev'">{{ envName }}</div>
